<template>
  <div id="app">
    
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  max-width: 750px;
  margin: 0 auto;
  font-family: "Avenir", "PingFang SC", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue